import { Component, OnInit, Input, Output } from '@angular/core';

import { PopoverController } from '@ionic/angular';

import { ChatService } from 'src/app/services/chat.service';

@Component({
  selector: 'app-localidad-popover',
  templateUrl: './localidad-popover.component.html',
  styleUrls: ['./localidad-popover.component.scss'],
})
export class LocalidadPopoverComponent implements OnInit {

  @Input() municipio;
  @Input() id;
  @Input() rol;
  @Input() token;
  @Input() urlBack;

  @Output() option;

  asentamientos: any;

  constructor(
    private popoverController: PopoverController,
    private chatService: ChatService) { }

  ngOnInit() {
    this.getLocalidades();
  }

  getLocalidades() {
    this.chatService.consultarAsentamiento(this.municipio, this.id, this.rol, this.token, this.urlBack).subscribe((data: any) => {
        console.log('Asentamientos obtenidos:', data);
        this.asentamientos = data.asentamientos;
      },
      (error) => {
        console.error('Error al consultar los asentamientos:', error);
      }
    );
  }

  getOption(asentamiento) {
    console.log(`Opción elegida(lado del hijo) id: ${asentamiento.id}, Nombre: ${asentamiento.asenta}`);
    this.option = { id: asentamiento.id, nombre: asentamiento.asenta };
    this.popoverController.dismiss(this.option);
  }

  closePopover() {
    this.popoverController.dismiss();
  }

}
